import { NgModule, LOCALE_ID } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { ToastyModule } from "ng2-toasty";
import { NgxSpinnerModule } from "ngx-spinner";
import { CookieService } from 'ngx-cookie-service';

import { CoreModule } from './core';
import { AppComponent } from './app.component';
import { LoginService } from './login/login.service';
import { SharedModule } from './shared/shared.module';
import { AuthGuard } from './shared/guards/auth-guard';
import { AppRoutingModule } from './app-routing.module';
import { CommonComponent } from './common/common.component';
import { NotificationService } from "./core/errors/services/notification.service";

// config locale pt-BR
import localePt from '@angular/common/locales/pt';
import { registerLocaleData } from '@angular/common';
import { CpfCnpjValidatorDirective } from "./shared/validator/cpf-cnpj.validator.directive";
registerLocaleData(localePt);

@NgModule({
  declarations: [
    AppComponent,
    CommonComponent,
    CpfCnpjValidatorDirective
  ],
  imports: [
    BrowserModule,
    CoreModule,
    SharedModule,
    AppRoutingModule,
    HttpClientModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    ToastyModule.forRoot(),
    NgxSpinnerModule
  ],
  providers: [
    AuthGuard,
    LoginService,
    CookieService,
    NotificationService,
    { provide: LOCALE_ID, useValue: 'pt-BR' }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
